import PropTypes from 'prop-types';

export const widthPropType = PropTypes.oneOfType([
  PropTypes.number.isRequired,
  PropTypes.string.isRequired
]);

export const heightPropType = PropTypes.oneOfType([
  PropTypes.number.isRequired,
  PropTypes.string.isRequired
]);

export const aspectRatioPropType = PropTypes.shape({
  w: PropTypes.number.isRequired,
  h: PropTypes.number.isRequired
});
